document.addEventListener('alpine:init', () => {
    Alpine.data('fullscreenSidebar', () => ({
        openFullscreenSidebar: false, 
        toggleFullscreenSidebar() {
             this.openFullscreenSidebar = ! this.openFullscreenSidebar ; 
             
             if(this.openFullscreenSidebar){
             
                document.querySelector('body').style.overflow = 'hidden';
                document.querySelector('body').style.position =  'fixed';
             
            }else {
            
                document.querySelector('body').style.overflow = 'auto';
                document.querySelector('body').style.position = 'relative';
            
            }
            }
    }))
})